/**
 * @generated SignedSource<<4165ed0c4010a186d4b563a67ff5b71c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateBankAccountInput = {
  anchorBalance: number;
  anchorDate: any;
  name: string;
};
export type EditBankAccountDialogCreateMutation$variables = {
  input: CreateBankAccountInput;
};
export type EditBankAccountDialogCreateMutation$data = {
  readonly createBankAccount: {
    readonly id: string;
  };
};
export type EditBankAccountDialogCreateMutation = {
  response: EditBankAccountDialogCreateMutation$data;
  variables: EditBankAccountDialogCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "createBankAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBankAccountDialogCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBankAccountDialogCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29728cb6e8f1b96b0f0f5411fc81ab44",
    "id": null,
    "metadata": {},
    "name": "EditBankAccountDialogCreateMutation",
    "operationKind": "mutation",
    "text": "mutation EditBankAccountDialogCreateMutation(\n  $input: CreateBankAccountInput!\n) {\n  createBankAccount(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbf94a3a30c6688cb2ebe4e18a74364e";

export default node;
